var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"DrieLuik"},[_c('Header'),_c('Panorama'),_c('Map'),_c('Carrousel')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }